import { makeAutoObservable } from "mobx";

class Store {
  started = false
  sceneLoaded = false
  needsRender = true
  loadingPercentage = 0
  hotspots = []
  currentHotspotId = null
  currentPanelHotspotId = null
  exitButtonVisible = false
  menuOpen = false
  hotspotPanelVisible = false
  hotspotPanelOrigin = [0, 0]

  constructor() {
    makeAutoObservable(this);
  }

  setStarted() {
    this.started = true;
  }

  setSceneLoaded() {
    this.sceneLoaded = true;
  }

  setHotspot(index, id, x, y, size) {
    let hotspot = this.hotspots.at(index);

    if (!hotspot) {
      hotspot = { id, x, y, size };
      this.hotspots[index] = hotspot;
    }

    hotspot.id = id;
    hotspot.x = x;
    hotspot.y = y;
    hotspot.size = size;
  }

  setHotspotVisited(id) {
    const hotspot = this.hotspots.find(hotspot => hotspot.id === id);

    if (hotspot) {
      hotspot.visited = true;
    }
  }

  setCurrentHotspot(id) {
    this.currentHotspotId = id;
  }

  setCurrentPanelHotspot(id) {
    this.currentPanelHotspotId = id;
  }

  setLoadingPercentage(percentage) {
    this.loadingPercentage = percentage;
  }

  setExitButtonVisible(value) {
    this.exitButtonVisible = value;
  }

  setHotspotPanelVisible(value) {
    this.hotspotPanelVisible = value;
  }

  setMenuOpen(value) {
    this.menuOpen = value;
  }

  setNeedsRender(value) {
    this.needsRender = value;
  }

  setHotspotPanelOrigin(x, y) {
    this.hotspotPanelOrigin[0] = x;
    this.hotspotPanelOrigin[1] = y;
  }

  setPlayAnimation(v) {
    this.playAnimation = v;
  }
}

const store = new Store();

export { store };